import { createAction, props } from '@ngrx/store'
import { AuthState, User } from './auth.state'
import { incomingSubscription } from '../../services/subscriptions'

export const login = createAction(
  '[Login Component] Login User',
  props<{ email: string; password: string }>()
)

export const loginSuccess = createAction('[Auth Effect] Login User Success', props<AuthState>())

export const loginFailure = createAction(
  '[Auth Effect] Login User Failure',
  props<{ error: string }>()
)

export const logout = createAction('[Auth Effect] Logout')

export const logoutSuccess = createAction(
  '[Auth Effect] Logout Success',
  props<{ success: string }>()
)

export const logoutFailure = createAction(
  '[Auth Effect] Logout Failure',
  props<{ error: string }>()
)

export const register = createAction(
  '[Login Component] Registration User',
  props<{
    firstName: string
    lastName: string
    email: string
    mobile: string
    businessName: string
    planId: string
    mode: 'trial' | 'buy'
    country: number
    state: number
    gstNumber: string
  }>()
)

export const registerSuccess = createAction(
  '[Auth Effect] Registration User Success',
  props<{ success: string; userId: string }>()
)

export const registerFailure = createAction(
  '[Auth Effect] Registration User Failure',
  props<{ error: string }>()
)

export const forgotPassword = createAction(
  '[Forgot Password] forgot Password',
  props<{ email: string }>()
)

export const forgotPasswordSuccess = createAction(
  '[Auth] Forgot Password Success',
  props<{ message: string }>()
)

export const forgotPasswordFailure = createAction(
  '[Auth] Forgot Password Failure',
  props<{ error: string }>()
)

export const resetPassword = createAction(
  '[Auth] Reset Password',
  props<{ token: string; email: string; password: string }>()
)

export const resetPasswordSuccess = createAction(
  '[Auth] Reset Password Success',
  props<{ message: string }>()
)

export const resetPasswordFailure = createAction(
  '[Auth] Reset Password Failure',
  props<{ error: string }>()
)

export const showThankYouMessage = createAction('[Registration] Show Thank You Message')

export const refreshToken = createAction('[Auth] Refresh Token')

export const refreshTokenSuccess = createAction(
  '[Auth] Refresh Token Success',
  props<{ accessToken: string; user: User }>()
)

export const refreshTokenFailure = createAction('[Auth] Refresh Token Failure')

export const loadCurrentUser = createAction('[Auth] Load Current User')

export const loadCurrentUserSuccess = createAction(
  '[Auth] Load Current User Success',
  props<{ user: User | null; accessToken?: string | null; refreshToken?: string | null }>()
)

export const loadCurrentUserFailure = createAction(
  '[Auth] Load Current User Failure',
  props<{ error: string }>()
)

export const resetThankYouMessage = createAction('[Auth] Reset Thank You Message')

//Following subscription actions (and effects) are temporarily set in auth actions
//As subscriptions state is created we may refactor these
export const loadSubscription = createAction(
  '[Subscription] Load Subscription',
  props<{ businessId: string }>()
)

export const loadSubscriptionSuccess = createAction(
  '[Subscription API] Load Subscription Success',
  props<{ subscription: incomingSubscription | null }>()
)

export const loadSubscriptionFailure = createAction(
  '[Subscription API] Load Subscription Failure',
  props<{ error: any }>()
)

// THIS CODE ADDED BY SHIVAM

export const updateUser = createAction('[Auth] Update User', props<{ user: any }>())

export const updateAuthUser = createAction('[Auth] Update User', props<{ user: User }>())

//7 may 2026
export const loadPermissions = createAction('[Auth] Load Permissions')

export const loadPermissionsSuccess = createAction(
  '[Auth API] Load Permissions Success',
  props<{ permissions: Record<string, string[]> }>()
)

export const loadPermissionsFailure = createAction(
  '[Auth API] Load Permissions Failure',
  props<{ error: string }>()
)

export const restoreSession = createAction(
  '[Auth Effect] Restore Session From Storage',
  props<AuthState>()
)

export const switchUser = createAction('[Auth] Switch User', props<{ userId: string }>())
export const switchUserSuccess = createAction(
  '[Auth] Switch User Success',
  props<{
    accessToken: string
    refreshToken: string
    user: any
    subscription: any
    // permissions: any
  }>()
)
export const switchUserFailure = createAction(
  '[Auth] Switch User Failure',
  props<{ error: string }>()
)

export const revertSwitchUser = createAction('[Auth] Revert Switch User')
export const revertSwitchUserSuccess = createAction(
  '[Auth] Revert Switch User Success',
  props<{
    accessToken: string
    user: any
    subscription: any
    // permissions: any
  }>()
)
export const revertSwitchUserFailure = createAction(
  '[Auth] Revert Switch User Failure',
  props<{ error: string }>()
)

// -------ENDED-------
